import { Controller } from 'stimulus';
import { initializeChart, adjustGraphDimensions } from "../packs/component_helpers";
import { createPieChart, createHorizontalBarChart } from "../packs/vega_chart_helpers";

export default class extends Controller {
  initialize() {
    $(".spinner-border").hide();
  }

  connect() {
    const view = this.element.dataset.view;
    let controller = this;

    if(view == "widget-container"){
      document.querySelectorAll(".stats-component").forEach(elem => {
        controller.renderComponent(elem);
      })
    }
    
  }

  updatePieChart(event) {
    let stats_component = $(event.target).parents(".stats-component")
    this.renderComponent(stats_component) 
  }

  updateWidgetView(event) {
    let widget_type = $(event.target).data("id")
    let existing_widgets_count = $(".stats-component").length
    let added = $(event.target).is(':checked')

    console.log(widget_type)

    if(added){
      existing_widgets_count = existing_widgets_count + 1
    } else {
      existing_widgets_count = existing_widgets_count - 1
    }

    if(existing_widgets_count > 0){
      $(".post-grid-view").addClass("post-grid-with-charts ml-3").removeClass("col-md-12")
      $(".widgets-container").addClass("widget-view")
    } else {
      $(".post-grid-view").removeClass("post-grid-with-charts ml-3").addClass("col-md-12")
      $(".widgets-container").removeClass("widget-view")
    }

    Rails.ajax({
      type: 'POST',
      url: `monitoring/update_widget_view`,
      data: $.param({component_name: widget_type, is_visible: $(event.target).is(':checked')}),
      dataType: 'json',
      success: (response) => {
        if (added) {
          $(".monitoring-stats").append(response)
          let widget_elem = $(`.monitoring-stats .stats-component.${widget_type}`)[0]
          this.renderComponent(widget_elem)
        } else {
          $(`.monitoring-stats .stats-component.${widget_type}`).remove()
        }
      }
    });

  }

  updateLineChart(event){
    let stats_component = $(event.target).parents(".stats-component")
    let chart_type = $(event.target).val()
    let body = stats_component.find(".card-body")

    var chart_container_class = ".line-chart-monitoring"
    initializeChart(chart_container_class, stats_component, {chartLayout: chart_type, dimensions: {height: body.height(), width: body.width() - 25}})
  }

  renderComponent(elem) {
    $(elem).find(".spinner-div").show();
    let component_name = $(elem).data("name")

    let param_string = window.location.search
    let breakdown_by = "";

    if(component_name == "breakdown_posts"){
      breakdown_by = $(elem).find("select.breakdown-select").val()
    }

    if(param_string.length > 0){
      param_string += `&component_name=${component_name}`
    } else {
      param_string = `?component_name=${component_name}`
    }

    if(breakdown_by) param_string += "&breakdown_by=" + breakdown_by

    Rails.ajax({
      type: 'GET',
      url: `monitoring/render_component${param_string}`,
      dataType: 'json',
      success: (response) => {
        $(elem).find(".spinner-div").hide();
        $(elem).find(".card-body").html(response);

        var chart_container_class = ".line-chart-monitoring"
        var pie_container_class = ".pie-chart-monitoring"
        var horizontal_bar_chart_class = `#${component_name} .horizontal-bar-chart-monitoring`

        if(component_name == "posts_over_time" && $(chart_container_class).length > 0){
          let body = $(elem).find(".card-body")
          initializeChart(chart_container_class, $(elem), {dimensions: {height: body.height(), width: body.width() - 25}})
        } else if (component_name == "breakdown_posts" && $(pie_container_class).length > 0) {
          createPieChart(pie_container_class)
        } else if (component_name == "significant_text" && $(horizontal_bar_chart_class).length > 0) {
          this.renderPopularTermsChart(elem, component_name, horizontal_bar_chart_class)
        } else if (component_name == "significant_terms" && $(horizontal_bar_chart_class).length > 0) {
          this.renderPopularTermsChart(elem, component_name, horizontal_bar_chart_class)
        }

      }
    });
  }

  renderPopularTermsChart(elem, component_name, horizontal_bar_chart_class){
    createHorizontalBarChart(horizontal_bar_chart_class)

    setTimeout(() => {
      var canvas_height = $(`#${component_name} ${horizontal_bar_chart_class} canvas`).height()
      $(elem).height(canvas_height + 100)
    }, 100);
  }

}